import React from 'react';
import { useTranslation } from 'react-i18next';
import { SearchMenu } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './no-search-results-state.style';

export type NoSearchResultsStateProps = {
  dense?: boolean;
};

export const NoSearchResultsState: React.FC<NoSearchResultsStateProps> = ({
  dense = false,
}) => {
  const { t } = useTranslation();

  return (
    <Styled.Container $dense={dense}>
      <Styled.IconContainer $dense={dense}>
        <Icon icon={SearchMenu} />
      </Styled.IconContainer>
      <Styled.Title>{t('general.labels.search.no-results')}</Styled.Title>
    </Styled.Container>
  );
};
